import * as React from 'react'
import { useForcedViewTheme } from '../theme'
import Logo from '@/components/Logo'

export default function DigitalDegreeLogo() {
  const theme = useForcedViewTheme()

  if (theme.logoBase64) {
    return <img src={theme.logoBase64} alt="Logo" className="max-h-12 w-auto" />
  }

  return (
    <Logo
      primary={theme.publicViewPrimaryColor}
      secondary={theme.publicViewSecondaryColor}
      className="w-32 h-12"
    />
  )
}
